import { render, staticRenderFns } from "./MembershipDetail.vue?vue&type=template&id=54d97c06"
import script from "./MembershipDetail.vue?vue&type=script&lang=ts"
export * from "./MembershipDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports